import React from 'react'
import { TextBoxLabel, TextBoxWrapper,TextBoxInput } from './TextBoxStyled'

const TextBox = () => {
  return (
    <TextBoxWrapper>
        <TextBoxLabel>Description</TextBoxLabel>
        <TextBoxInput></TextBoxInput>
    </TextBoxWrapper>
  )
}

export default TextBox